/**
 * Prioritized playlist IDs that should always appear first in the specified order
 */
export const FEATURED_PLAYLIST_IDS = [
  'a1f5a4c8-613b-46c1-8704-eca83622a670',
  'a4ee3cb1-3539-43e6-a289-34404680d085',
  '817dd6d0-7710-4d78-a160-93eefbeeca7a'
];

/**
 * Sorts playlists putting featured ones first (in specified order), then sorts the rest by name
 */
export function sortPlaylistsByPriority<T extends { id: string; name?: string }>(playlists: T[]): T[] {
  if (!Array.isArray(playlists)) {
    console.error("Expected an array of playlists, but received:", playlists);
    return [];
  }
  
  if (playlists.length === 0) {
    return [];
  }
  
  // Create two arrays: one for featured playlists and one for the rest
  const featured: (T | null)[] = [null, null, null]; // Initialize with nulls to maintain order
  const others: T[] = [];
  
  // Separate playlists into featured and others based on ID
  playlists.forEach(playlist => {
    const index = FEATURED_PLAYLIST_IDS.indexOf(playlist.id);
    if (index !== -1) {
      featured[index] = playlist; // Place in correct featured position
    } else {
      others.push(playlist);
    }
  });
  
  // Filter out any null elements from featured array (in case not all featured playlists were found)
  const cleanFeatured = featured.filter(Boolean) as T[];
  
  // Sort the non-featured playlists by name if available, otherwise keep original order
  const sortedOthers = [...others].sort((a, b) => {
    if (a.name && b.name) {
      return a.name.localeCompare(b.name);
    }
    return 0;
  });
  
  // Combine featured and sorted playlists
  return [...cleanFeatured, ...sortedOthers];
}
